import React from "react";
import { useSnapshot } from "valtio";

import { designStore, generalConfigStore } from "@store";

import { getBackgroundPathById } from "@helpers/general";

type PropsType = {
    children: React.ReactNode;
    selectedSubStep?: ProjectMainContentItemType;
    subStep?: any;
};

export function PreviewBackgroundWrapper({
    children,
    selectedSubStep,
    subStep,
}: PropsType): JSX.Element {
    const {
        imageKey,
        files,
        project: { template },
    } = useSnapshot(generalConfigStore);
    const { activePageName } = useSnapshot(designStore);

    let BackgroundPge: any;
    if (selectedSubStep !== undefined) {
        BackgroundPge = (template.pages.subSteps[
            selectedSubStep.shortName as string
        ] as PageType)!.background;
    } else if (
        selectedSubStep === undefined &&
        subStep !== undefined &&
        subStep === 2
    ) {
        BackgroundPge = (template.pages.subSteps[
            "printerOptionsConfirmationEmail"
        ] as PageType)!.background;
    } else {
        BackgroundPge = (template.pages.ways[activePageName] as PageType)!
            .background;
    }

    const [
        isBackgroundPreviewActive,
        setIsBackgroundPreviewActive,
    ] = React.useState(BackgroundPge.active);

    const [backgroundSrc, setBackgroundSrc] = React.useState(
        getBackgroundPathById(BackgroundPge.id, files) as {
            url: string;
            type: string;
        }
    );

    React.useEffect(() => {
        setBackgroundSrc(
            getBackgroundPathById(BackgroundPge.id, files) as {
                url: string;
                type: string;
            }
        );
        setIsBackgroundPreviewActive(BackgroundPge.active);
    }, [activePageName, files, BackgroundPge]);

    return (
        <React.Fragment>
            {isBackgroundPreviewActive === true ? (
                backgroundSrc.type === "video" ? (
                    <React.Fragment>
                        <video
                            key={imageKey}
                            autoPlay={true}
                            muted={true}
                            loop={true}
                            style={{
                                height: "725px",
                                width: "430px",
                                objectFit: "cover",
                                position: "fixed",
                            }}
                            src={backgroundSrc.url}
                        />
                        {children}
                    </React.Fragment>
                ) : (
                    <div
                        key={imageKey}
                        style={{
                            backgroundImage: `url('${backgroundSrc.url}')`,
                            height: "725px",
                            backgroundSize: "cover",
                        }}
                    >
                        {children}
                    </div>
                )
            ) : (
                <div
                    style={{
                        height: "725px",
                    }}
                >
                    {children}
                </div>
            )}
        </React.Fragment>
    );
}
